__turbopack_context__.v({
  "open": "StyleOverlay-module-scss-module__DeJKCW__open",
  "panel": "StyleOverlay-module-scss-module__DeJKCW__panel",
});
